import loadingStyles from '../shared/Loading.module.css';
import {
  parseCurrencyDigits,
  formatUsdWithSpace,
  FINANCIAL_PROFILE_CURRENCY_INPUT_IDS,
  FINANCIAL_PROFILE_SLIDER_AGE_IDS,
} from '../OnboardingAgent/FinancialProfilePanel';
import { formatNumberWithCommas } from '../../utils/onboardingUtils';
import { getGlobalTypography } from '../../utils/globalTypography';

export function buildChartReportHtml(fragments, userName) {
  const title = userName || 'User';
  const fragmentStyles = fragments.styles || '';
  const type = getGlobalTypography();
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Chart Report - ${title}</title>${type.fontLinksHtml}<script src="https://cdn.plot.ly/plotly-3.4.0.min.js"></script>${fragmentStyles}<style>
          *{box-sizing:border-box}body{margin:0;padding:1.5rem 1.25rem 2rem;font-family:${type.sans};font-size:17px;line-height:1.5;color:${type.muted};background:linear-gradient(135deg,#f8f9fa 0%,#e9ecef 100%);animation:rcgFadeIn 0.78s cubic-bezier(0.22,1,0.36,1) both}
          #charts-container,#summary-container,#detailed-container{margin-bottom:1.5rem}
          #detailed-container{margin-bottom:0}
          </style></head><body>
          <div id="charts-container">${fragments.charts || ''}</div>
          <div id="summary-container">${fragments.summary_table || ''}</div>
          <div id="detailed-container">${fragments.detailed_table || ''}</div>
          </body></html>`;
}

/**
 * Read-only value display aligned with UserProfile number inputs:
 * financial-profile currency → `$ 3,000` (space after $); children count & slider ages plain; other numbers comma-grouped.
 */
export function getAdminReadOnlyAnswerDisplay(question, answerStr) {
  if (!question || question.type !== 'number') {
    return answerStr;
  }
  const qid = question.id;
  const trimmed = String(answerStr ?? '').trim();

  if (FINANCIAL_PROFILE_CURRENCY_INPUT_IDS.has(qid)) {
    if (trimmed === '') return '';
    return formatUsdWithSpace(parseCurrencyDigits(trimmed));
  }
  if (qid === 'children_number' || FINANCIAL_PROFILE_SLIDER_AGE_IDS.has(qid)) {
    return trimmed;
  }
  const cleaned = trimmed.replace(/,/g, '');
  if (cleaned === '') return '';
  return formatNumberWithCommas(cleaned);
}

export function AdminTableLoadingState({ message }) {
  return (
    <div className={loadingStyles['loading-container']}>
      <div className={loadingStyles['loading-spinner']}>
        <div className={loadingStyles['spinner-ring']} />
        <div className={loadingStyles['spinner-ring']} />
        <div className={loadingStyles['spinner-ring']} />
      </div>
      <p>{message}</p>
    </div>
  );
}
